import { cn } from '../../lib/utils';

interface FilterPillOption {
  value: string;
  label: string;
  count?: number;
}

interface FilterPillsProps {
  options: FilterPillOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function FilterPills({ options, value, onChange, className }: FilterPillsProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-1 rounded-xl border border-gray-200 bg-gray-50 p-1',
        className,
      )}
    >
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={cn(
            'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold transition-all duration-150',
            value === opt.value
              ? 'bg-brand-500 text-white shadow-sm shadow-brand-500/25'
              : 'text-gray-500 hover:bg-white hover:text-gray-800',
          )}
        >
          {opt.label}
          {opt.count !== undefined && (
            <span
              className={cn(
                'rounded-full px-1.5 py-0.5 text-[9px] font-bold leading-none',
                value === opt.value ? 'bg-white/20 text-white' : 'bg-gray-200 text-gray-600',
              )}
            >
              {opt.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
